import { P2GAlert, P2GBox } from '@parcel2go/core-ui';
import useIsOnline from '~/hooks/use-is-online';

const ConnectionStatus = () => {
  const isOnline = useIsOnline();
  return (
    !isOnline && (
      <P2GBox
        style={{ position: 'fixed', zIndex: 2, width: '100%', left: 0, bottom: 0, right: 0 }}
        pl={2}
        pr={2}
        pb={2}
      >
        <P2GAlert severity="error" style={{ background: 'white' }}>
          You are currently offline. Please check your internet connection and try again.
        </P2GAlert>
      </P2GBox>
    )
  );
};
export default ConnectionStatus;
